module.exports = __webpack_public_path__ + "static/media/ES-Uji.ad7937f9.png";